import React from "react";

export default function Watermark() {
  return (
    <div
      aria-hidden
      className="fixed bottom-6 left-1/2 -translate-x-1/2 pointer-events-none z-0 w-[min(70vw,520px)]"
      style={{ opacity: 0.03 }}
    >
      <img src="/logo_trans.png" alt="" className="w-full" />
    </div>
  );
}
